enum DragAndDropFileUploaderStateEnum {
  Neutral = "neutral",
  Hover = "hover",
  Dropped = "dropped",
  Pending = "pending",
  Error = "error",
  Success = "success",
  TypeError = "typeerror",
}

interface UploaderProps {
  // The key in the object we send to the API, e.g. "serviceAreaFile" for geography uploads
  apiKeyName: string;
  disabled?: boolean;
  // If the file will be displayed in the UI, e.g. a tutorial, this can help the user confirm the display name
  displayName?: string;
  // Used if we're in a wizard and go back in steps, so we can show it's already complete
  hasBeenSuccessful?: boolean;
  // for some reason, the function here seems to have scope issues.
  // passing it in like this.regionSetService.createFromFile.bind(this.regionSetService) fixes it, if you have issues
  onUpload?: (file: FormData) => Promise<unknown>;
  onMultipleUpload?: (file: File) => Promise<unknown>;
  onRemove?: (documentKey: number) => void;
  allowUpload?: boolean;
  // This is a string used as the HTML accept property, e.g. ".qpt"
  // also used for frontend validation
  filetype?: string;
  onUploadStateChange?: (uploadState: DragAndDropFileUploaderStateEnum) => void;
  // adds the .small class, which makes the component smaller
  small?: boolean;
  testId: string;
  title?: string;
  //An optional function to download the file that was uploaded via this component, using the file key, which in most of the cases would be a database ID or Blob path.
  handleDownloadLink?: (fileKey: number) => void
}

export { UploaderProps, DragAndDropFileUploaderStateEnum };
